import { useStaticQuery, graphql } from 'gatsby';

export const siteMetadata = {
  title: 'Online Diagram Software & Visual Solution | Lucidchart',
  metaImage:
    'https://d2slcw3kip6qmk.cloudfront.net/marketing/pages/chart/meta/Lucidchart-working-in-editor.png',
  siteUrl: 'https://www.lucidchart.com',
  cmsUrl: 'https://lucidchart-cms.gatsby.lucidutil.com',
  productUrl: ''
};

interface Query {
  site: {
    siteMetadata: typeof siteMetadata;
  };
}

export const useSiteMetadata = () => {
  const { site } = useStaticQuery<Query>(
    graphql`
      query SiteMetaData {
        site {
          siteMetadata {
            title
            metaImage
            siteUrl
            cmsUrl
            productUrl
          }
        }
      }
    `
  );

  return site.siteMetadata;
};
